// `WholeRuns` and `Timestamp` (design-system spec §3.3, `fit`, D-336). A cell
// value made of two parts, a timestamp's date and time or an amount and its
// currency, renders as two runs that each stay whole. In a `fit` table's cell
// the runs may stand on two lines, so a narrow column reads the time under the
// date, or the currency under the amount, instead of holding the table wider
// than the glass. Anywhere else the cell keeps its own wrapping: an age cell
// is `nowrap`, so a timestamp reads on one line as it did.
//
// The text is the same text: `textContent` is exactly the one string the
// value's formatter returns, the gap is that string's own whitespace, and a
// value its splitter cannot cut renders as the bare string. The <wbr> after
// the gap adds no text. It is what lets the runs part where the gap is a
// no-break space, which is how Intl joins an amount to its currency.

import { timestampParts } from "../lib/datetime";
import type { TwoRuns } from "../lib/two-runs";

export function WholeRuns({ runs }: { runs: TwoRuns }) {
  if (runs.second.length === 0) return <>{runs.first}</>;
  return (
    <span className="ds-runs">
      <span className="ds-run">{runs.first}</span>
      {runs.gap}
      <wbr />
      <span className="ds-run">{runs.second}</span>
    </span>
  );
}

/** `formatTimestamp`'s text with its date and time as two whole runs. */
export function Timestamp({
  iso,
  locale,
  timeZone,
}: {
  iso: string | null | undefined;
  locale?: string | undefined;
  timeZone?: string | null | undefined;
}) {
  return <WholeRuns runs={timestampParts(iso, locale, timeZone)} />;
}
